export interface PdfTemplateListRow {
  id: number;
  template_family: string;
  document_type: string;
  name: string;
  template: string;
  sample_data: Record<string, unknown> | null;
  notes: string | null;
  is_active: boolean;
  version: number;
  created_at: string;
  updated_at: string | null;
}

export function templateFamilyPrimaryRow(
  familyRows: readonly PdfTemplateListRow[],
): PdfTemplateListRow | null {
  if (familyRows.length === 0) return null;
  return familyRows.find((row) => row.is_active) ?? familyRows[0]!;
}

export function templateFamilyOlderRows(
  familyRows: readonly PdfTemplateListRow[],
): PdfTemplateListRow[] {
  const primary = templateFamilyPrimaryRow(familyRows);
  if (primary == null) return [];
  return familyRows.filter((row) => row.id !== primary.id);
}

export function templateFamilyVisibleRows(
  familyRows: readonly PdfTemplateListRow[],
  expanded: boolean,
): PdfTemplateListRow[] {
  const primary = templateFamilyPrimaryRow(familyRows);
  if (primary == null) return [];
  if (expanded) return [...familyRows];
  return [primary];
}

export function templateGroupTitle(familyRows: readonly PdfTemplateListRow[]): string {
  const reference = familyRows.find((row) => row.is_active) ?? familyRows[0];
  if (reference == null) return "";
  const familyLabel = pdfTemplateFamilyLabel(reference.template_family);
  if (familyLabel !== reference.template_family) return familyLabel;
  return reference.name
    .replace(/\s+v\d+\s*$/i, "")
    .replace(/\s+pdf\s*$/i, "")
    .trim();
}

export function templateDetailTitle(row: PdfTemplateListRow): string {
  return row.name.replace(/\s+v\d+\s*$/i, "").replace(/\s+pdf\s*$/i, "").trim();
}

export function templateVersionLabel(row: PdfTemplateListRow): string {
  return `v${String(row.version)}`;
}

export function pdfTemplateDocumentTypeLabel(documentType: string): string {
  switch (documentType) {
    case "transfer-document":
      return "Transfer document";
    case "boxes-pdf":
      return "Shipment packing slip";
    case "invoice-pdf":
      return "Invoice PDF";
    case "send-invoice":
      return "Send invoice";
    default:
      return documentType;
  }
}

export function pdfTemplateFamilyLabel(templateFamily: string): string {
  switch (templateFamily) {
    case "transfer-internal-origin":
      return "Transfer — internal origin";
    case "transfer-internal-origin-pallet":
      return "Transfer — internal origin (pallet)";
    case "transfer-external-origin":
      return "Transfer — external origin";
    case "boxes-pdf-shipment-carton":
      return "Shipment packing slip — carton";
    case "boxes-pdf-shipment-pallet":
      return "Shipment packing slip — pallet";
    case "invoice-pdf-gosi":
      return "GOSI invoice PDF";
    case "send-invoice-gosi":
      return "GOSI send invoice";
    default:
      return templateFamily;
  }
}
